/* Ўзбекча (кирилл). Та же лексика, что в латинском словаре, тем же письмом,
   каким читает старшая половина цеха.

   ТРЕБУЕТ ВЫЧИТКИ НОСИТЕЛЕМ НА ЗАВОДЕ ДО ЗАПУСКА — вместе с латинским.

   Два словаря, а не автоматическая транслитерация. Соблазн был: правила
   перевода латиницы в кириллицу формальны, и одну функцию написать проще,
   чем вести второй файл. Но правила эти не однозначны — ‘ў’ и ‘у’, ‘қ’ и ‘к’,
   ‘ҳ’ и ‘х’ различаются в кириллице и сливаются в латинице, — и обратный
   перевод давал бы слова, которые выглядят почти правильно. Почти правильное
   слово на экране у станка хуже честно непереведённого: его читают
   и спотыкаются, а не пропускают. */

export default {
  common: {
    cancel: 'Бекор қилиш',
    ok: 'Тайёр',
    confirm: 'Тасдиқлаш',
    close: 'Ёпиш',
    refresh: 'Янгилаш',
    loading: 'юкланмоқда…',
    exit: 'Чиқиш',
    reset: 'Тозалаш',
    comment: 'Изоҳ',
    commentOptional: 'Изоҳ (мажбурий эмас)',
    commentRequired: 'Бу сабаб учун изоҳ мажбурий',
    reason: 'Сабаб',
    machine: 'Дастгоҳ',
    shift: 'Смена',
    theme: 'Мавзу',
    language: 'Тил',
    understood: 'Тушунарли',
    noConnection: 'Алоқа йўқ',
    connected: 'Алоқа бор',
    readOnly: 'кўриш',
  },

  login: {
    subtitle: 'Ишлаб чиқаришни оператив бошқариш тизими',
    login: 'Логин',
    password: 'Парол',
    submit: 'Кириш',
    checking: 'Текширилмоқда…',
    toTerminal: 'Сех терминалидан кириш',
    toPassword: 'Логин ва парол билан кириш',
  },

  terminal: {
    machine: 'Дастгоҳ',
    setupTitle: 'Терминални созлаш',
    setupHint: 'Қурилма бириктирилмаган. Терминал кодини ва у яратилганда берилган токенни киритинг.',
    code: 'Терминал коди',
    token: 'Қурилма токени',
    bind: 'Бириктириш',
    tabNumber: 'Табель рақами',
    pin: 'ПИН',
    pickMachine: 'Дастгоҳни танланг',
  },

  op: {
    needTabPin: 'Табел рақами ва PIN',
    needTabPinWhy: 'Табел рақами ва PIN мажбурий: маҳсулот одамга ёзилади',
    scanOrType: 'Биркани сканерланг ёки кодни киритинг',
    leaveTitle: 'Сменадан чиқиш',
    leaveText: 'Чиқиш белгилансинми: {name}?',
    leaveDetail: 'Ҳозирлик соатлари шу вақт билан ёпилади. Смена бошлиғи сменани ёпишда уларни тўғрилай олади',
    leaveOk: 'Чиқишни белгилаш',
    qStart: 'Операция бошланиши',
    qPause: 'Пауза',
    qDone: 'Операция якуни',
    qCallSetter: 'Созловчини чақириш',
    qCallSupervisor: 'Смена бошлиғини чақириш',
    byTab: ' · таб. {tab}',
    jobReadyOne: 'Топшириқ ишга тайёр',
    jobReadyMany: 'Топшириқлар ишга тайёр',
    pressStart: 'Дастгоҳ ёнига турганингизда «Бошлаш»ни босинг',
    chooseOne: 'Қайси бирига киришаётганингизни танланг',
    stockWarn: 'Материал сарфи тўлиқ ҳисобдан чиқарилмади',
    stockWarnHint: 'Маҳсулот қабул қилинди. Омборчига ёки смена бошлиғига айтинг',
    setupTook: 'Қайта созлаш {time} давом этди',
    machineIs: '{code} дастгоҳи.',
    machineIdleHint: '{code} дастгоҳи. Смена бошлиғи топшириқ беради ва у шу ерда ўзи пайдо бўлади.',
    viewOnly: 'Иш жойи {code} · фақат кўриш.',
    shiftTarget: 'смена топшириғида',
    shiftTargetOf: 'смена топшириғида: {qty} {unit}',
    start: 'Бошлаш',
    tabNumber: 'Табел рақами',
    crewSelfNote: 'Ҳар ким ўзини белгилайди: PIN — одам терминал ёнида турганини билдиради',
    mark: 'Белгилаш',
    commentRequired: 'Бу сабаб учун изоҳ мажбурий',
    confirm: 'Тасдиқлаш',
    commentOptional: 'Изоҳ (мажбурий эмас)',
    whatHappened: 'Нима бўлди (мажбурий эмас)',
    call: 'Чақириш',
    whoseOutput: 'Маҳсулот шу одамга ёзилади. У шу дастгоҳда сменага белгиланган бўлиши керак',
    tagCode: 'Биркадаги код',
    shareNote: '«Улуш» — ҳисоб-китоб: бригада маҳсулоти топшириш пайтида дастгоҳ ёнида бўлганлар орасида тенг бўлинган. Бу ўлчов эмас, баҳо.',
    workplace: 'Иш жойи',
    noJob: 'Топшириқ берилмаган',
    noJobHint: 'Смена бошлиғи топшириқ беради ва у шу ерда ўзи пайдо бўлади.',
    jobFromSupervisor: 'Топшириқни участка экранида, дастгоҳ картасидаги '
      + '«Топшириқ» тугмаси орқали алмаштириш мумкин.',
    readOnlyNote: 'Маҳсулотни топшириш ва операцияни ёпиш — дастгоҳ терминалидан: '
      + 'ҳисобда буни айнан ким қилгани қолиши керак.',
    remaining: 'қолди',
    of: 'дан',
    byButtons: 'Тугмалар билан',
    byKeyboard: 'Клавиатура билан',
    all: 'Ҳаммаси',
    good: 'Яроқли',
    scrap: 'Яроқсиз',
    defect: 'Нуқсон',
    waste: 'Қайтариладиган чиқинди',
    wasteHint: 'Қирқим, учлари, қиринди — қайта эритишга кетадиган металл',
    wasteQty: 'Қанча, {unit}',
    wastePlaceholder: 'масалан: ғалтак учлари',
    pallet: 'Поддон йиғилди',
    palletHint: 'Идиш поддондаги ғалтаклар сонига қараб ҳисобдан чиқарилади',
    palletCoils: 'Поддонда нечта ғалтак',
    palletNoNorm: 'норма йўқ',
    palletFact: 'факт',
    palletMissing: 'Фактсиз ҳисобдан чиқарилмайди: {list}',
    palletQueued: 'Поддон: {n} ғалтак',
    pause: 'Пауза',
    resume: 'Ишни давом эттириш',
    finish: 'Операцияни якунлаш',
    pauseReason: 'Тўхтатиш сабаби',
    doPause: 'Тўхтатиш',
    callSupervisor: 'Смена бошлиғини чақириш',
    callSetter: 'Созловчини чақириш',
    callWaiting: 'кутинг, чақирув тизимга қабул қилинди',
    callSupervisorCalled: 'Смена бошлиғи чақирилди',
    callSetterCalled: 'Созловчи чақирилди',
    callWhat: 'Нима бўлди (мажбурий эмас)',
    callHint: 'Қисқача: ишга нима халақит бермоқда',
    doCall: 'Чақириш',
    inPlan: 'смена топшириғида',
  },

  /* Сокращение «операция» перед её номером. */
  opSeq: 'оп.',

  batch: {
    inWork: 'Ишда',
    notMarked: 'партия белгиланмаган',
    notMarkedWhy: '— яроқсиз маҳсулот номсиз қолади',
    mark: 'Партияни белгилаш',
    scrapBin: 'Чиқинди идишга',
    binNotPicked: 'идиш танланмаган',
    pickBin: 'Идишни танлаш',
    tagCode: 'Биркадаги код',
    tagHintBatch: 'Дастгоҳ ёнидаги металлнинг биркаси',
    tagHintBin: 'Брак тушадиган бункер биркаси',
    dlgBatch: 'Ишдаги партия',
    dlgBin: 'Чиқинди идиши',
  },

  tools: {
    leftHours: '{h} соат иш қолди',
    leftQty: '{n} дона қолди',
    callNote: 'Асбоб: {list}',
    onMachine: 'Дастгоҳда',
    remove: 'Ечиш',
    ok: 'меъёрда',
    soon: 'ресурс тугамоқда',
    spent: 'ресурс тугади',
    tellSetter: 'Созловчига хабар бериш',
  },

  setup: {
    running: 'Қайта созлаш кетмоқда',
    finish: 'Қайта созлашни якунлаш',
    took: 'Қайта созлаш вақти',
    start: 'Қайта созлашни бошлаш',
    startBtn: 'Бошлаш',
    button: 'Қайта созлаш',
    hint: 'Масалан: Ø6 дан Ø9 га',
  },

  crew: {
    onShift: 'Сменада',
    markMe: 'Сменада белгиланиш',
    mark: 'Белгилаш',
    left: 'Кетди',
    nobody: 'Ҳеч ким белгиланмаган. Смена таркибдан бошланади',
    pinWhy: 'Ҳар ким ўзи белгиланади: ПИН одам терминал ёнида турганини билдиради',
    shareHint: '«Улуш» — ҳисоб-китоб: бригада маҳсулоти топширилган пайтда '
      + 'дастгоҳ ёнида бўлганлар орасида тенг бўлинади. Бу ўлчов эмас, баҳо',
    whoReports: 'Ким топширади',
    whoReportsHint: 'Маҳсулот шу одам номига ёзилади. '
      + 'У шу дастгоҳда сменада белгиланган бўлиши керак',
    doReport: 'Топшириш',
  },

  andon: {
    reasonNotSet: 'Сабаб кўрсатилмаган',
    setterCalled: 'Созловчи чақирилди',
    supervisorCalled: 'Смена бошлиғи чақирилди',
    plant: 'Корхона',
    shiftNamed: '{code} сменаси',
    token: 'Қурилма токени',
    bind: 'Боғлаш',
    byLogin: 'Логин ва парол билан кириш',
    exit: 'Чиқиш',
    offline: 'Алоқа йўқ · маълумотлар {ago} олдин',
    notMarked: 'Белгиланмаган',
    noReason: 'сабаб кўрсатилмаган',
    target: 'мақсад {p}',
    quality: 'яроқлилик {p}',
    title: 'АНДОН',
    setupTitle: 'Тахтани созлаш',
    setupHint: 'Қурилма бириктирилмаган. Тахта кодини ва у яратилганда берилган '
      + 'қурилма токенини киритинг.',
    code: 'Тахта коди',
    unbind: 'Бу тахтани узиш',
    run: 'Ишламоқда',
    down: 'Тўхтади',
    maint: 'ТХ',
    idle: 'Кутмоқда',
    oeeShift: 'Смена OEE',
    goodShift: 'Сменада яроқли',
    attention: 'ЭЪТИБОР ТАЛАБ ҚИЛАДИ',
    calm: 'ТИНЧ',
    allQuiet: 'Тўхтаган ускуна ва очиқ чақирувлар йўқ',
  },

  /* Навигация. Оператор видит её каждую смену, поэтому переведена
     целиком, включая конторские разделы: пункт на чужом языке рядом
     с переведёнными читается как поломка, а не как «сюда не ходи». */
  nav: {
    groupShop: "Сех",
    groupQuality: "Сифат",
    groupMetal: "Металл",
    groupPlans: "Режалар ва натижалар",
    operator: "Иш жойи",
    operatorShort: "Жой",
    melt: "Шихта",
    area: "Участка",
    maintenance: "Техник хизмат",
    maintenanceShort: "ТХ",
    quality: "Назорат",
    qualityShort: "СТК",
    lab: "Лаборатория",
    labShort: "Лаб.",
    certificates: "Сертификатлар",
    certificatesShort: "Серт.",
    stock: "Материаллар",
    stockShort: "Матер.",
    batches: "Партиялар",
    scrap: "Чиқинди",
    orders: "Буюртмалар",
    shift: "Смена",
    production: "Ишлаб чиқариш",
    productionShort: "Шарҳ",
    admin: "Созламалар",
    company: "Корхона",
  },

  status: {
    retry: 'Қайта юбориш',
    discard: 'Ташлаб юбориш',
    ok: 'Алоқа бор',
    pending: 'Юборилмоқда: навбатда {n} та',
    offline: 'Алоқа йўқ',
    offlineQueued: 'Алоқа йўқ · навбатда {n} та',
    degraded: 'Ҳодисалар мавжуд эмас, маълумотлар сўров бўйича янгиланади',
    blocked: 'Навбат тўхтади',
  },

  shift: {
    named: '{code} смена',
    namedWith: '{code} смена · {name}',
    left: '{time} қолди',
    over: 'смена тугади',
    noBounds: 'смена чегаралари белгиланмаган',
    hours: '{h} соат',
    hoursMinutes: '{h} соат {m} дақиқа',
    minutes: '{m} дақиқа',
    progress: 'Смена {p}% ўтди',
  },

  tool: {
    writeOff: 'ресурс тугади',
    regrind: 'қайта чархлаш вақти',
    soon: 'ресурс тугаяпти',
  },

  melt: {
    title: 'Шихта',
    subtitle: 'Компонентлар вазни ва рецептдаги улуши. Печ ёпилгунга қадар ҳисобланади',
    compCount: '{n} та компонент',
    hangTag: 'Биркани идишга осиб қўйинг. Бу партиядан чиқадиган ҳамма нарса у билан боғланади',
    next: 'Кейинги шихта',
    what: 'Нима эритамиз',
    choose: '— танланг —',
    noRecipes: 'Ҳеч бир материалга рецепт берилмаган. Уни созламаларда, материаллар маълумотномасида киритинг',
    outTag: 'Натижа биркаси',
    other: 'Бошқаси',
    outPh: 'Натижа учун тоза бирка',
    total: 'Шихтада жами',
    offRecipe: 'Рецептдан ташқари',
    byRecipe: 'рецепт бўйича',
    components: 'Компонентлар',
    compPh: 'Компонент биркаси',
    noTag: 'Биркасиз',
    thComponent: 'Компонент',
    thTag: 'Бирка',
    thRecipe: 'Рецепт бўйича',
    thWeight: 'Вазн',
    thShare: 'Улуш',
    scanTag: 'биркани сканерланг',
    scanOutFirst: 'Шихтани ёпиш учун натижа биркасини сканерланг',
    close: 'Шихтани ёпиш',
    pp: 'ф.п.',
    tagTaken: '{code} аллақачон боғланган — тоза бирка олинг',
    switchTitle: 'Эритилаётган нарсани алмаштириш',
    switchText: 'Вазнлар аллақачон киритилган. Мақсадни алмаштириш қаторларни бошқа рецепт бўйича қайта йиғади.',
    switchDetail: 'Киритилган вазнлар йўқолади',
    switchOk: 'Алмаштириш',
    offTitle: 'Шихта рецептдан четда',
    offText: 'Рухсат этилган чегарадан ташқари: {what}. Шихта барибир ёпилсинми?',
    offTextAny: 'Шихта рецептдан четда. Барибир ёпилсинми?',
    offDetail: 'Четланиш эритма ёзувида қолади ва партиянинг келиб чиқиш занжирига ўтади',
  },
  enum: {
    orderStatus: {
      draft: 'Қоралама', pending: 'Келишувда', approved: 'Келишилган',
      planned: 'Режалаштирилган', released: 'Чиқарилган', run: 'Ишда',
      paused: 'Тўхтатилган', done: 'Якунланган', closed: 'Ёпилган', cancelled: 'Бекор қилинган',
    },
    orderOrigin: { sales: 'Мижоз буюртмасига', internal: 'Ички', stock: 'Омборга' },
    equipmentType: {
      enterprise: 'Корхона', area: 'Сех', workcenter: 'Участка',
      machine: 'Ускуна', buffer: 'Буфер зонаси',
    },
    reasonCategory: {
      scrap: 'Якуний яроқсиз', defect: 'Тузатса бўладиган нуқсон', downtime: 'Режадан ташқари тўхташ',
      maint: 'Режали тўхташ / ТХ', pause: 'Операцияни тўхтатиб туриш', cancel: 'Буюртмани бекор қилиш',
      setup: 'Қайта созлаш',
    },
    defectOrigin: {
      own: 'Ўз босқичи', upstream: 'Олдинги босқич', material: 'Кирувчи материал',
      metallurgy: 'Эритма кимёси', tooling: 'Асбоб ва ускуна', unknown: 'Ўрнатилмаган',
    },
    equipmentState: {
      run: 'Ишламоқда', idle: 'Кутмоқда', maint: 'Режали тўхташ / ТХ',
      down: 'Тўхташ / авария', off: 'Ўчирилган',
    },
    opStatus: {
      wait: 'Кутмоқда', active: 'Бажарилмоқда', paused: 'Тўхтатилган',
      done: 'Якунланган', skipped: 'Ўтказиб юборилган',
    },
    outputKind: { good: 'Яроқли', scrap: 'Якуний яроқсиз', defect: 'Тузатса бўладиган нуқсон', rework: 'Қайта ишлангандан кейин', waste: 'Қайтариладиган чиқинди' },
    role: {
      operator: 'Оператор', qc: 'СТК назоратчиси', setter: 'Созловчи',
      supervisor: 'Смена бошлиғи', planner: 'Режалаштирувчи', manager: 'Раҳбарият',
      admin: 'Администратор',
    },
  },
};
